import { combineReducers } from 'redux';

import collectionsState, { collectionsInitialState } from './collections';
import filesState, { filesInitialState } from './files';
import groupDialogState, { groupDialogInitialState } from './groupDialog';
import groupsState, { groupsInitialState } from './groups';
import reviewState, { reviewInitialState } from './review';

export const datalakeState = combineReducers({ collectionsState, groupsState, filesState, groupDialogState, reviewState })
export const datalakeInitialState = {
  collectionsState: collectionsInitialState, 
  groupsState: groupsInitialState, 
  filesState: filesInitialState,
  groupDialogState: groupDialogInitialState,
  reviewState: reviewInitialState
}